import { render } from "./Badge.vue?vue&type=template&id=4bb54379"
import script from "./Badge.vue?vue&type=script&lang=js"
export * from "./Badge.vue?vue&type=script&lang=js"
script.render = render

export default script